import React, { useState } from 'react'

/**
 * provides `open(ModalComp, optArgs) -> Promise` which resolves when modal is closed
 * note the modal promise only rejects for errors otherwise it just never resolves
 * the whole idea behind promises is that they are composable so you can:
 * `open(FirstModal, opts).then(() => open(NextModal, opts)).then(() => refetch())`
 *
 * TODO: use portal
 */
export const useModal = () => {
  const [currentModal, setModal] = useState<any>(null)
  const hide = () => setModal(null)

  return React.useMemo(() => {
    return {
      currentModal,

      // TODO: improve types
      open: <P extends { resolve?; reject }>(
        Modal: React.ComponentType<P>,
        args = {}
      ) =>
        new Promise<any>((resolve, reject) => {
          setModal(
            // @ts-expect-error
            // align is in fact not necessary, it's just a prop we are passing
            // to all "new" modals and we will eventually make all modals
            // left-aligned in the future (and then it can be removed)
            <Modal
              align="left"
              resolve={resolve}
              reject={(rej) => {
                hide()

                // ignore anything else
                if (rej instanceof Error) {
                  reject(rej)
                }
              }}
              {...args}
            />
          )
        }).finally(hide)
    }
  }, [currentModal])
}
